import * as http from "../../../../../utils/http";
import { MyAccountStoreProduct } from "../types";

/**
 * Starts checkout for a Test Lab product from the My Account store.
 *
 * These products have no funnel product page or cart, so we ask the api to mint
 * a fresh OTC cart for the logged-in customer (POST /cart/create-otc), persist
 * its id + token in the session, then route to the shipping page — which loads
 * that cart via the CART_ORDER middleware (cart_id / cart_token headers).
 */

interface OrderNowRedirectInput {
  product: MyAccountStoreProduct;
  country: string;
  language: string;
}

interface CreateOtcCartResponse {
  status: string;
  cartID: number;
  cartToken: string;
}

export const orderNowRedirect = (input: OrderNowRedirectInput): Promise<void> => {
  const { product, country, language } = input;

  return http
    .postToServer(
      "cart/create-otc",
      {
        productItemID: product.productItemID,
        catalogID: product.catalogID,
        quantity: 1,
        language,
        country: country.toLowerCase(),
      },
      [http.MIDDLEWARES.CUSTOMER_ID],
    )
    .then((response: { data: CreateOtcCartResponse }) => {
      const data = response?.data;
      if (data?.status !== "ok" || !data.cartID || !data.cartToken) {
        throw new Error("Failed to create cart for order");
      }
      // Persist the new cart so the shipping page picks it up on full reload.
      const eventsTracking = (window as any).eventsTracking;
      eventsTracking?.setData?.("cart_id", data.cartID, true);
      eventsTracking?.setData?.("cart_token", data.cartToken, true);
      window.location.href = `/shipping/${country}/${language}`;
    });
};
